import React, { FC, useRef } from "react";
import { signoutRedirect } from "../oidcClient/userService";
import Countdown from "./Helper/Countdown";
import { CustomModal } from "./Common/Modal/CustomModal";

interface ISessionTimeoutProps {
    showModal: boolean;
    onStayAlive(event: any): void;
    countDownMinutes: number;
}

const SessionTimeout: FC<ISessionTimeoutProps> = props => {
    const countDown: any = useRef();

    const getCountDown = (): Date => {
        const now = new Date();
        const result = now;
        result.setMinutes(now.getMinutes() + props.countDownMinutes);
        return result;
    };

    const onStayAlive = (e: any) => {
        if (countDown) {
            clearInterval(countDown.interval);
        }
        props.onStayAlive(e);
    };

    const onLogout = () => {
        onCountDownComplete();
    };

    const onCountDownComplete = () => {
        sessionStorage.removeItem("isVisited");
        signoutRedirect();
    };

    return (
        <CustomModal
            className="session-timeout-modal"
            show={props.showModal}
            onHide={onLogout}
            title="Session Expiring"
            cancelButtonName="Log Out"
            confirmButtonName="Continue Working"
            onSubmit={onStayAlive}
            onCancelButtonClick={onLogout}
            isConfirmModal={true}
        >
            <div>
                Your session will expire in&nbsp;
                <Countdown date={getCountDown()} onComplete={onCountDownComplete} ref={countDown} /> Do you
                want to continue working?
            </div>
        </CustomModal>
    );
};

export default SessionTimeout;
